'use client';
import { SocialMedia } from '@/page-builder/global/mappers/footer.mapper';
import Image from '@/components/atoms/image';
import React, { useState } from 'react';

interface SocialIconProps {
  social: SocialMedia;
}

const socialIcons: Record<string, string> = {
  facebook: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 1.30469C13.4087 1.30469 11.8826 1.93683 10.7574 3.06205C9.63214 4.18727 9 5.71339 9 7.30469V9.30469H7C6.44772 9.30469 6 9.7524 6 10.3047V14.3047C6 14.857 6.44772 15.3047 7 15.3047H9V22.3047C9 22.857 9.44772 23.3047 10 23.3047H14C14.5523 23.3047 15 22.857 15 22.3047V15.3047H17C17.4589 15.3047 17.8589 14.9924 17.9701 14.5472L18.9701 10.5472C19.0448 10.2485 18.9777 9.93199 18.7882 9.68928C18.5987 9.44656 18.3079 9.30469 18 9.30469H15V7.30469H18C18.5523 7.30469 19 6.85697 19 6.30469V2.30469C19 1.7524 18.5523 1.30469 18 1.30469H15Z" fill="white"/>
    </svg>`,
  linkedin: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 1.30469C2.34315 1.30469 1 2.64783 1 4.30469C1 5.96154 2.34315 7.30469 4 7.30469C5.65685 7.30469 7 5.96154 7 4.30469C7 2.64783 5.65685 1.30469 4 1.30469Z" fill="white"/>
    <path d="M16 7.30469C14.1435 7.30469 12.363 8.04219 11.0503 9.35494C9.7375 10.6677 9 12.4482 9 14.3047V21.3047C9 21.857 9.44771 22.3047 10 22.3047H14C14.5523 22.3047 15 21.857 15 21.3047V14.3047C15 14.0395 15.1054 13.7851 15.2929 13.5976C15.4804 13.41 15.7348 13.3047 16 13.3047C16.2652 13.3047 16.5196 13.41 16.7071 13.5976C16.8946 13.7851 17 14.0395 17 14.3047V21.3047C17 21.857 17.4477 22.3047 18 22.3047H22C22.5523 22.3047 23 21.857 23 21.3047V14.3047C23 12.4482 22.2625 10.6677 20.9497 9.35494C19.637 8.04219 17.8565 7.30469 16 7.30469Z" fill="white"/>
    <path d="M2 8.30469C1.44772 8.30469 1 8.7524 1 9.30469V21.3047C1 21.857 1.44772 22.3047 2 22.3047H6C6.55228 22.3047 7 21.857 7 21.3047V9.30469C7 8.7524 6.55228 8.30469 6 8.30469H2Z" fill="white"/>
    </svg>`,
  x: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_675_13563)">
    <path d="M24 23.7797L14.6138 10.0974L14.6299 10.1102L23.0908 0.304688H20.2641L13.3717 8.28548L7.89756 0.304688H0.480192L9.2421 13.0778L0 23.7797H2.82673L10.4906 14.8993L16.5826 23.7797H24ZM6.77711 2.43994L19.944 21.6476H17.7031L4.52341 2.43994H6.77391H6.77711Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_675_13563">
    <rect width="24" height="23.475" fill="white" transform="translate(0 0.304688)"/>
    </clipPath>
    </defs>
    </svg>`
};

const outlineIcons: Record<string, string> = {
  facebook: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 1.30469C13.4087 1.30469 11.8826 1.93683 10.7574 3.06205C9.63214 4.18727 9 5.71339 9 7.30469V9.30469H7C6.44772 9.30469 6 9.7524 6 10.3047V14.3047C6 14.857 6.44772 15.3047 7 15.3047H9V22.3047C9 22.857 9.44772 23.3047 10 23.3047H14C14.5523 23.3047 15 22.857 15 22.3047V15.3047H17C17.4589 15.3047 17.8589 14.9924 17.9701 14.5472L18.9701 10.5472C19.0448 10.2485 18.9777 9.93199 18.7882 9.68928C18.5987 9.44656 18.3079 9.30469 18 9.30469H15V7.30469H18C18.5523 7.30469 19 6.85697 19 6.30469V2.30469C19 1.7524 18.5523 1.30469 18 1.30469H15Z" stroke="white" stroke-width="1.5" fill="none"/>
    </svg>`,
  linkedin: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 1.30469C2.34315 1.30469 1 2.64783 1 4.30469C1 5.96154 2.34315 7.30469 4 7.30469C5.65685 7.30469 7 5.96154 7 4.30469C7 2.64783 5.65685 1.30469 4 1.30469Z" stroke="white" stroke-width="1.5" fill="none"/>
    <path d="M16 7.30469C14.1435 7.30469 12.363 8.04219 11.0503 9.35494C9.7375 10.6677 9 12.4482 9 14.3047V21.3047C9 21.857 9.44771 22.3047 10 22.3047H14C14.5523 22.3047 15 21.857 15 21.3047V14.3047C15 14.0395 15.1054 13.7851 15.2929 13.5976C15.4804 13.41 15.7348 13.3047 16 13.3047C16.2652 13.3047 16.5196 13.41 16.7071 13.5976C16.8946 13.7851 17 14.0395 17 14.3047V21.3047C17 21.857 17.4477 22.3047 18 22.3047H22C22.5523 22.3047 23 21.857 23 21.3047V14.3047C23 12.4482 22.2625 10.6677 20.9497 9.35494C19.637 8.04219 17.8565 7.30469 16 7.30469Z" stroke="white" stroke-width="1.5" fill="none"/>
    <path d="M2 8.30469C1.44772 8.30469 1 8.7524 1 9.30469V21.3047C1 21.857 1.44772 22.3047 2 22.3047H6C6.55228 22.3047 7 21.857 7 21.3047V9.30469C7 8.7524 6.55228 8.30469 6 8.30469H2Z" stroke="white" stroke-width="1.5" fill="none"/>
    </svg>`
};

export const SocialIcon: React.FC<SocialIconProps> = ({ social }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const getIconSvg = () => {
    let platform = social.platform.toLowerCase();
    if (platform === 'twitter' || platform === 'x') {
      platform = 'x';
    }
    
    if ((platform === 'facebook' || platform === 'linkedin') && !isHovered) {
      return outlineIcons[platform] || '';
    }
    
    return socialIcons[platform] || '';
  };
  
  return (
    <a 
      href={social.url}
      title={social.label || ''}
      aria-label={social.label}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center transition-all duration-300 hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {social.icon?.url ? (
        <Image src={social.icon.url} alt="" width={24} height={24} unoptimized className="h-24 w-24 object-contain" />
      ) : (
        <span aria-hidden="true" dangerouslySetInnerHTML={{ __html: getIconSvg() }} />
      )}
    </a>
  );
};

export const SocialNav: React.FC<{ socialMedias: SocialMedia[] }> = ({ socialMedias }) => {
  return (
    <nav
      className="xs:col-span-4 md:col-start-2 md:col-span-6 xl:col-span-4 xs:py-16 md:py-32"
      aria-label="Redes sociais"
    >
      <ul className="flex justify-center xl:justify-between">
        {socialMedias.map((social, index) => (
          <li className='p-16' key={index}>
            <SocialIcon social={social} />
          </li>
        ))}
      </ul>
    </nav>
  );
};
